import { render, staticRenderFns } from "./PeriodicForm.vue?vue&type=template&id=e0891a88"
import script from "./PeriodicForm.vue?vue&type=script&lang=js"
export * from "./PeriodicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports